import { SimpleModal } from "../../components";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleFormControl } from "../../components/form/SimpleFormControl";
import { Form, Formik } from "formik";
import { IActionsModal } from "src/app/types/actionsModal";
import { UpsertOnSiteEditSchema } from "src/app/types/orders/order";
import Pacman from "../../components/layout/Pacman";
import { useGetOrderById } from "src/app/hooks";
import { UpsertContentDTOSchema } from "src/app/types/content";
import { ContentTransport } from "src/app/transports/content";

const UpsertEditOnSiteModalContainer = (props: IActionsModal<{ orderId: number }>) => {
    const { handleClose = () => {}, entity, updateGridOnSave = () => {} } = props;
    const [loading, setLoading] = useState(false);
    const { formatMessage } = useIntl();

    const { order, loading: orderLoading } = useGetOrderById(entity?.orderId);

    const handleSubmit = async (values: any) => {
        setLoading(true);
        const currentValues = {
            ...values,
            orderId: order?.id,
        };
        try {
            const res = await ContentTransport.saveContentInOrder(currentValues, values.id);
            await updateGridOnSave(res, false, true);
            toast.success(formatMessage({ id: "common.notification.success" }));
            handleClose();
        } catch (error: any) {
            toast.error(formatMessage({ id: "common.notification.error" }));
        } finally {
            setLoading(false);
        }
    };

    const maxMetaTitleLength = 80;
    const maxMetaDescriptionLength = 180;

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.editContent" })}
            handleClose={handleClose}
            loading={loading || orderLoading}
            formId="editContentForm"
            buttonConfirmationLabel={formatMessage({ id: "common.action.save" })}
            showModal={true}
            modalProps={{ size: "lg" }}
        >
            {orderLoading || !order ? (
                <Pacman />
            ) : (
                <>
                    <Formik
                        initialValues={
                            order?.content
                                ? ContentTransport.formTransformer(order?.content)
                                : UpsertContentDTOSchema.getDefault()
                        }
                        validationSchema={UpsertOnSiteEditSchema}
                        onSubmit={handleSubmit}
                        enableReinitialize
                    >
                        {(formikProps) => (
                            <Form id="editContentForm">
                                <div className="editContentFormWrapper">
                                    <label>{formatMessage({ id: "common.field.title" })}</label>
                                    <SimpleFormControl name="title" />

                                    <label>{formatMessage({ id: "common.field.metaTitle" })}</label>
                                    <span className="mx-2">
                                        {"("}
                                        {formikProps.getFieldProps("metaTitle").value.length}
                                        {" /"}
                                    </span>
                                    <b>
                                        {maxMetaTitleLength}
                                        {" )"}
                                    </b>

                                    <SimpleFormControl name="metaTitle" />

                                    <label>
                                        {formatMessage({ id: "common.field.metaDescription" })}
                                    </label>
                                    <span className="mx-2">
                                        {"("}
                                        {formikProps.getFieldProps("metaDescription").value.length}
                                        {" /"}
                                    </span>
                                    <b>
                                        {maxMetaDescriptionLength}
                                        {" )"}
                                    </b>
                                    <SimpleFormControl
                                        as="textarea"
                                        name="metaDescription"
                                        rows={3}
                                    />
                                </div>
                            </Form>
                        )}
                    </Formik>
                </>
            )}
        </SimpleModal>
    );
};

export default UpsertEditOnSiteModalContainer;
